import { render, staticRenderFns } from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=template&id=e4871632&scoped=true"
import script from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=style&index=0&id=e4871632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4871632",
  null
  
)

export default component.exports